import { useMemo } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useOrderGetNewSchemaQuery } from 'api/generated/graphql';
import { parseOrderSchema, useError } from 'api/helpers';

export const useOrderGetNewSchema = () => {
  const { data, loading, error: apolloError } = useOrderGetNewSchemaQuery();

  const error = useError(apolloError);

  const orderSchema = useMemo(() => {
    if (!data?.orderSchema) {
      return undefined;
    }
    return parseOrderSchema(data.orderSchema);
  }, [data?.orderSchema]);

  return {
    orderSchema,
    loading,
    error,
  };
};
